import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { TreasuryAccount } from '../../../models/treasury.account.model';
import { GlobalSwal } from '../../../styles/swal.style';
import { Company } from '../../../models/company.model';
import { AccountingAccount } from '../../../models/accounting.account.model';
import { AccountingAccountDA } from '../../../services/admin/accounting.account.service';
import { Error } from '../../../models/error.model';
import { CompanyAccountingAvailableAccounts } from '../../../models/company.accounting.available.accounts.model';
import { getError } from '../../../languages/translations/response';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';

export interface TreasuryPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  accountingCashAccountsForCompany: AccountingAccount[] | null,
  accountingPostalAccountsForCompany: AccountingAccount[] | null,
  accountingBankAccountsForCompany: AccountingAccount[] | null,
  accountingCurrentAccountAccountsForCompany: AccountingAccount[] | null,
  setAccountingCashAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  setAccountingPostalAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  setAccountingBankAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  setAccountingCurrentAccountAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  loadAccountingAccountsForCompany: Function,
  loadAccountingAvailableAccountsForCompany: Function,
  loadTreasuryAccountsForCompany: Function
};

let errorResponse: Error, accounitngAvailableAccuntsResponse: CompanyAccountingAvailableAccounts;

const TreasuryPage: React.FunctionComponent<TreasuryPageProps> = props => {
  const {setRoute, companyForUser, treasuryAccountsForCompany, loadAccountingAccountsForCompany, loadTreasuryAccountsForCompany} = UseOutletContext()
  const {lang} = StateLanguage()

  const [accountingCashAccountsForCompany, setAccountingCashAccountsForCompany] = useState<AccountingAccount[] | null>(null)
  const [accountingPostalAccountsForCompany, setAccountingPostalAccountsForCompany] = useState<AccountingAccount[] | null>(null)
  const [accountingBankAccountsForCompany, setAccountingBankAccountsForCompany] = useState<AccountingAccount[] | null>(null)
  const [accountingCurrentAccountAccountsForCompany, setAccountingCurrentAccountAccountsForCompany] = useState<AccountingAccount[] | null>(null)

  const loadAccountingAvailableAccountsForCompany = async (id_company: string) => {
    await AccountingAccountDA.getAccountingAvailableAccounts(id_company).then( (response) => {
      if (response.status === 200) {
        accounitngAvailableAccuntsResponse = response.data

        setAccountingCashAccountsForCompany(accounitngAvailableAccuntsResponse.accounting_accounts.cash)
        setAccountingPostalAccountsForCompany(accounitngAvailableAccuntsResponse.accounting_accounts.postal)
        setAccountingBankAccountsForCompany(accounitngAvailableAccuntsResponse.accounting_accounts.bank)
        setAccountingCurrentAccountAccountsForCompany(accounitngAvailableAccuntsResponse.accounting_accounts.shareholder ?? accounitngAvailableAccuntsResponse.accounting_accounts.current_account)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  useEffect( () => {
    if (companyForUser) {
      setAccountingCashAccountsForCompany(null)
      setAccountingPostalAccountsForCompany(null)
      setAccountingBankAccountsForCompany(null)
      setAccountingCurrentAccountAccountsForCompany(null)
      loadAccountingAvailableAccountsForCompany(companyForUser.id)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  return (
    <Outlet context={{setRoute, companyForUser, treasuryAccountsForCompany, accountingCashAccountsForCompany, accountingPostalAccountsForCompany, accountingBankAccountsForCompany, accountingCurrentAccountAccountsForCompany, setAccountingCashAccountsForCompany, setAccountingPostalAccountsForCompany, setAccountingBankAccountsForCompany, setAccountingCurrentAccountAccountsForCompany, loadAccountingAccountsForCompany, loadAccountingAvailableAccountsForCompany, loadTreasuryAccountsForCompany}}></Outlet>
  );
}

export function UseOutletContextTreasury() {
  return useOutletContext<ContexType>()
};

export default TreasuryPage;
